import { config } from "./domain-config";
import { Endpoints } from "../../endpoints";

export const getFaqText = async () => {
  const x = await document
    .querySelector("a-scene")
    .systems.data.fetch(Endpoints.faqPage());

  const faqPageLang = "en";
  const productName = config.productName;

  switch (productName) {
    case "afri-verse":
      return x[productName] || x["en"] || {};
    default:
      return x[faqPageLang] || x["en"] || {};
  }
};